import React, { useState } from 'react';
import { Check, X, Trash2 } from 'lucide-react';

const CircularButton = ({ 
  label,
  manageClick,
  randomIcon,
  size = 48,
  bgcolor
}: any) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Detect icon based on label/randomIcon
  const getIcon = () => {
    const iconText = (randomIcon || label || '').toLowerCase();
    
    if (iconText.includes('save') || iconText.includes('create') || 
        iconText.includes('ok') || iconText.includes('submit') || 
        iconText.includes('confirm') || iconText.includes('yes')) {
      return <Check size={size * 0.5} color="white" />;
    }
    
    if (iconText.includes('cancel') || iconText.includes('close') || 
        iconText.includes('no') || iconText.includes('reject')) {
      return <X size={size * 0.5} color="white" />;
    }
    
    if (iconText.includes('delete') || iconText.includes('remove') || 
        iconText.includes('clear') || iconText.includes('trash')) {
      return <Trash2 size={size * 0.5} color="white" />;
    }
    
    // Default to check icon
    return <Check size={size * 0.5} color="white" />;
  };

  // Detect color based on label/bgcolor
  const getBackgroundColor = () => {
    if (bgcolor) return bgcolor;
    
    const labelText = (label || '').toLowerCase();
    
    // Negative actions - Red
    if (labelText.includes('delete') || labelText.includes('remove') || 
        labelText.includes('cancel') || labelText.includes('close') || 
        labelText.includes('clear') || labelText.includes('reject') ||
        labelText.includes('no')) {
      return '#ef4444'; // Red
    }
    
    // Positive actions - Green
    return '#10b981'; // Green
  };

  const getHoverColor = () => {
    const baseColor = getBackgroundColor();
    
    // Darken the color on hover
    if (baseColor === '#ef4444') return '#dc2626'; // Darker red
    if (baseColor === '#10b981') return '#059669'; // Darker green
    
    // For custom colors, just slightly darken
    return baseColor;
  };

  const buttonStyle:any = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: isHovered ? getHoverColor() : getBackgroundColor(),
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    boxShadow: isHovered 
      ? '0 4px 12px rgba(0, 0, 0, 0.15)' 
      : '0 2px 6px rgba(0, 0, 0, 0.1)',
    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
    position: 'relative'
  };

  const tooltipStyle:any = {
    position: 'absolute',
    bottom: `${size + 12}px`,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#333',
    color: 'white',
    padding: '6px 12px',
    borderRadius: '6px',
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 1000,
    opacity: showTooltip ? 1 : 0,
    transition: 'opacity 0.2s ease',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
  };

  const arrowStyle:any = {
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderTop: '6px solid #333'
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {showTooltip && label && (
        <div style={tooltipStyle}>
          {label}
          <div style={arrowStyle} />
        </div>
      )}
      <button
        style={buttonStyle}
        onClick={manageClick}
        onMouseEnter={() => {
          setIsHovered(true);
          setShowTooltip(true);
        }}
        onMouseLeave={() => {
          setIsHovered(false);
          setShowTooltip(false);
        }}
      >
        {getIcon()}
      </button>
    </div>
  );
};

export default CircularButton;